import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueWaypoint from 'vue-waypoint'
import browserDetect from 'vue-browser-detect-plugin'
import Hotjar from 'vue-hotjar'
import hover from './directives/hover.directive'
Vue.config.productionTip = false

// Directives
Vue.directive('hover', hover())

// Waypoint
Vue.use(VueWaypoint)

// Hotjar
Vue.use(Hotjar, {
  id: '1816928'
})

// Browser Detection
Vue.use(browserDetect)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
